export default "__VITE_ASSET__Dlm500q5__"